export default "__VITE_ASSET__yBw9xwNO__"